import { useState } from 'react'
import { Button } from '@/components/shadcn/button'
import { Label } from '@/components/shadcn/label'
import { DateTimeFilterPicker } from '@/components/form-components/DateTimeFilterPicker'
import { TileFilterPopover } from '@/components/ui/TileFilterPopover'
import { IconV2FilterOutline } from '@icons/IconV2FilterOutline'

export type LogTimeFilters = {
  startTime: string
  endTime: string
}

export function defaultLogTimeFilters(): LogTimeFilters {
  return {
    startTime: new Date(Date.now() - 5 * 60 * 1000).toISOString(),
    endTime: new Date().toISOString(),
  }
}

export function LogTimeFilterPopover({
  filters,
  onChange,
}: {
  filters: LogTimeFilters
  onChange: (filters: LogTimeFilters) => void
}) {
  const [open, setOpen] = useState(false)
  const [draft, setDraft] = useState(filters)

  return (
    <TileFilterPopover
      icon={<IconV2FilterOutline size={18} />}
      open={open}
      onOpenChange={(nextOpen) => {
        setOpen(nextOpen)
        if (nextOpen) setDraft(filters)
      }}
    >
      <div className="space-y-3">
        <div className="text-sm font-medium">Log time range</div>
        <div className="space-y-1.5">
          <Label>Start time</Label>
          <DateTimeFilterPicker
            value={draft.startTime}
            onChange={(startTime) => setDraft((prev) => ({ ...prev, startTime: startTime ?? '' }))}
            placeholder="Start time"
            className="w-full"
          />
        </div>
        <div className="space-y-1.5">
          <Label>End time</Label>
          <DateTimeFilterPicker
            value={draft.endTime}
            onChange={(endTime) => setDraft((prev) => ({ ...prev, endTime: endTime ?? '' }))}
            placeholder="End time"
            className="w-full"
          />
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="ghost" size="sm" onClick={() => setDraft(defaultLogTimeFilters())}>
            Reset
          </Button>
          <Button
            size="sm"
            onClick={() => {
              onChange(draft)
              setOpen(false)
            }}
          >
            Apply
          </Button>
        </div>
      </div>
    </TileFilterPopover>
  )
}
